import { v4 as uuidv4 } from 'uuid';

export const SHOPPING_BASKET_ID_REGEX = new RegExp(
  /^[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}$/i
);

export const isAShoppingBasketId = (
  shoppingBasketId: string
): shoppingBasketId is typeof uuidv4 => {
  return SHOPPING_BASKET_ID_REGEX.test(shoppingBasketId);
};
